import React from "react";
import ModalNew from "../../../../../components/ui/popup/Modal";
import { PopupHeader } from "../../../../../components/ui/popup/common";

const SignAuthErrorModal = ({ isOpen, error, onClose, onRetry }) => {
  if (!isOpen || !error) return null;

  return (
    <ModalNew>
      <PopupHeader title="Sign Authorization" setOpenState={onClose} />
      <div style={{ padding: "20px", textAlign: "center" }}>
        <p style={{ color: "#850000", marginBottom: "20px" }}>{error}</p>
        <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
          <button
            type="button"
            className="cta-button secondary"
            onClick={onClose}
          >
            Close
          </button>
          <button
            type="button"
            className="cta-button primary"
            onClick={onRetry}
          >
            Try Again
          </button>
        </div>
      </div>
    </ModalNew>
  );
};

export default SignAuthErrorModal;
